import { ACCESS_TOKEN } from "../constants";

export const useAuth = () => {
    const storedToken = localStorage.getItem(ACCESS_TOKEN);
    const token = storedToken ? JSON.parse(storedToken) : "";    
    if(token){
        return true
    }
    return false
  };